import some from 'lodash/some';

import { SCROLLABLE_PATHS } from '../constants/main';

export const getIndependentScrolling = ({ location: { pathname } }) =>
    some(SCROLLABLE_PATHS, (path) => pathname.indexOf(path) > -1);
